<template>
    <div id="ChatbotAiPrompt">
        <div>
            <h1>Chatbot AI Prompt</h1>
            <p>
                Artificial intelligence learns and determines how it should behave by being given instructions about a
                specific task or problem using the 'prompt' feature.
            </p>
            <a-textarea
                v-model="promptText"
                placeholder="Enter the prompt"
                :auto-size="{ minRows: 2 }"
                style="min-height: 200px"
            />
        </div>
        <hr />
        <div class="parameter-tuning" :key="key">
            <h1>AI Parameter Tunings</h1>
            <p>
                You can tune the AI parameters to make the AI more responsive and accurate. These parameters are used to
                control the AI's behavior and how it responds to user inputs.
            </p>
            <div>
                <FeatureItem
                    title="Tempature"
                    icon="ChatAiIcon"
                    v-model="temperature"
                    description="What sampling temperature to use, between 0 and 2. Higher values like 0.8 will make the output more random, while lower values like 0.2 will make it more focused and deterministic."
                    type="number"
                    :min="0.01"
                    :max="2"
                    :step="0.1"
                    v-if="story.ai"
                    number-format="float"
                />
            </div>

            <div>
                <FeatureItem
                    title="Top-P"
                    icon="ChatAiIcon"
                    v-model="topP"
                    description="An alternative to sampling with temperature, called nucleus sampling, where the model considers the results of the tokens with top_p probability mass. So 0.1 means only the tokens comprising the top 10% probability mass are considered.
We generally recommend altering this or temperature but not both."
                    type="number"
                    :min="0.01"
                    :max="1"
                    :step="0.1"
                    v-if="story.ai"
                    number-format="float"
                />
            </div>

            <div class="modes">
                <strong> Tool Choices </strong>
                <div class="mode-items" :key="key">
                    <FeatureItem
                        title="None"
                        icon="ChatAiIcon"
                        v-model="toolChoiceNone"
                        description="None means the model will not call any tools and instead generates a message"
                        type="switch"
                        v-if="story.ai"
                    />

                    <FeatureItem
                        title="Auto"
                        icon="ChatAiIcon"
                        v-model="toolChoiceAuto"
                        description="Auto mode is the default value and means the model can pick between generating a message or calling one or more tools."
                        type="switch"
                        v-if="story.ai"
                    />

                    <FeatureItem
                        title="Required"
                        icon="ChatAiIcon"
                        v-model="toolChoiceRequired"
                        description="Required mode is  the model must call one or more tools before responding to the user"
                        type="switch"
                        v-if="story.ai"
                    />
                </div>
            </div>
        </div>
        <div class="settings-btn">
            <SupsisButton ghost @click="clearPrompt"> Cancel</SupsisButton>
            <SupsisButton primary @click="updatePrompt">Save</SupsisButton>
        </div>
    </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import SupsisButton from "../../../Settings/components/SupsisButton.vue";
import CommingSoonData from "../ComingSoon.vue";
import { sendSocketMessage } from "../../../../../utils/socketStream";
import FeatureItem from "../../../Settings/components/FeatureItem.vue";
import log2 from "../../../../../utils/log2";
import _ from "lodash";
import StringUtils from "../../../../../utils/StringUtils";

const log = log2("ChatbotAiPrompt");
export default {
    name: "ChatbotAiPrompt",
    components: {
        FeatureItem,
        SupsisButton,
        CommingSoonData,
    },
    props: {
        storyId: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            promptText:
                "Sen bir websitenin çağrı merkezinde çalışan müşterilere cevap veren bir canlı destek personelisin. Bilmediğin şeyler hakkında cevap verme.  Seninle websitesine gelen ziyaretciler konuşacak.",
            story: {},
            toolChoiceNone: false,
            toolChoiceAuto: true,
            toolChoiceRequired: false,
            temperature: 0.5,
            topP: 1,
            key: "test",

            Math,
        };
    },
    computed: {
        ...mapState({
            stories: (state) => state.CB.stories,
            site: (state) => state.site.site,
        }),
    },
    mounted() {
        window.logs = [];
        const story = this.stories.find((story) => story.id === this.storyId);
        if (story.ai && !story.ai.temperature) {
            story.ai.temperature = 0.5;
        }
        if (story.ai && !story.ai.top_p) {
            story.ai.top_p = 1;
        }
        if (story.ai && !story.ai.tool_choice) {
            story.ai.tool_choice = "auto";
            this.switchToolChoice("auto");
        }

        if (story && story.ai && story.ai.prompt) {
            this.promptText = story.ai.prompt;
        }
        this.story = story;
        this.temperature = story.ai?.temperature;
        this.topP = story.ai?.top_p;
        this.switchToolChoice(story.ai?.tool_choice);
        this.initialized = true;
        this.key = this.getKey();
    },
    methods: {
        ...mapActions({
            updateStorySingleKey: "CB/updateStorySingleKey",
        }),
        getKey() {
            return StringUtils.hashCodeObj({
                ai: this.story.ai,
                toolChoiceNone: this.toolChoiceNone,
                toolChoiceAuto: this.toolChoiceAuto,
                toolChoiceRequired: this.toolChoiceRequired,
            });
        },
        async switchToolChoice(mode) {
            log("switchToolChoice", mode);
            window.logs.push({ log: "switchToolChoice", params: { mode } });
            //await new Promise((r) => setTimeout(r, 500));
            this.toolChoiceNone = mode === "none";
            this.toolChoiceAuto = mode === "auto";
            this.toolChoiceRequired = mode === "required";
            // if (mode === "none" && this.toolChoiceNone === false) {
            //     this.toolChoiceNone = true;
            //     if (this.toolChoiceAuto === true) this.toolChoiceAuto = false;
            //     if (this.toolChoiceRequired === true) this.toolChoiceRequired = false;
            // }
            // if (mode === "auto" && this.toolChoiceAuto === false) {
            //     this.toolChoiceAuto = true;
            //     if (this.toolChoiceNone === true) this.toolChoiceNone = false;
            //     if (this.toolChoiceRequired === true) this.toolChoiceRequired = false;
            // }
            // if (mode === "required" && this.toolChoiceRequired === false) {
            //     this.toolChoiceRequired = true;
            //     if (this.toolChoiceNone === true) this.toolChoiceNone = false;
            //     if (this.toolChoiceAuto === true) this.toolChoiceAuto = false;
            // }
            this.key = this.getKey();
        },
        async updateStoryToolChoice() {
            log("updateStoryToolChoice");
            window.logs.push({ log: "updateStoryToolChoice" });
            //await new Promise((r) => setTimeout(r, 500));

            if (this.toolChoiceNone && this.story.ai.tool_choice !== "none") {
                this.story.ai.tool_choice = "none";
                this.changeToolChoice(this.story.ai.tool_choice);
            }
            if (this.toolChoiceAuto && this.story.ai.tool_choice !== "auto") {
                this.story.ai.tool_choice = "auto";
                this.changeToolChoice(this.story.ai.tool_choice);
            }
            if (this.toolChoiceRequired && this.story.ai.tool_choice !== "required") {
                this.story.ai.tool_choice = "required";
                this.changeToolChoice(this.story.ai.tool_choice);
            }
            this.key = this.getKey();

            log("updateStoryToolChoice", this.story.ai.tool_choice);
        },
        updatePrompt() {
            const prompt = this.promptText.trim();
            this.key = this.getKey();
            this.updateStorySingleKey({
                id: this.story._id,
                key: "ai.prompt",
                value: prompt,
            }).then(() => {
                this.$message.success("Prompt updated successfully");
                sendSocketMessage("chatbot/v2 prompt-changed", {
                    siteId: this.site._id,
                    storyId: this.story._id,
                    prompt,
                });
            });
        },
        clearPrompt() {
            this.promptText = "";
        },
        async changeTemperature(temperature) {
            log("changeTemperature from story", temperature);
            window.logs.push({ log: "changeTemperature from story", params: { temperature } });
            //await new Promise((r) => setTimeout(r, 500));
            this.story.ai.temperature = temperature;
            this.key = this.getKey();
            this.updateStorySingleKey({
                id: this.story._id,
                key: "ai.temperature",
                value: temperature,
            }).then(() => {
                this.$message.success("Temperature updated successfully");
                sendSocketMessage("chatbot/v2 temperature-changed", {
                    siteId: this.site._id,
                    storyId: this.story._id,
                    temperature,
                });
            });
        },
        async changeTopP(topP) {
            log("changeTopP from story", topP);
            window.logs.push({ log: "changeTopP from story", params: { topP } });
            //await new Promise((r) => setTimeout(r, 500));
            this.story.ai.top_p = topP;
            this.key = this.getKey();
            this.updateStorySingleKey({
                id: this.story._id,
                key: "ai.top_p",
                value: topP,
            }).then(() => {
                this.$message.success("Top-P updated successfully");
                sendSocketMessage("chatbot/v2 top-p-changed", {
                    siteId: this.site._id,
                    storyId: this.story._id,
                    topP,
                });
            });
        },
        async changeToolChoice(toolChoice) {
            log("changeToolChoice from story", toolChoice);
            window.logs.push({ log: "changeToolChoice from story", params: { toolChoice } });
            //await new Promise((r) => setTimeout(r, 500));
            this.key = this.getKey();
            this.updateStorySingleKey({
                id: this.story._id,
                key: "ai.tool_choice",
                value: toolChoice,
            }).then(() => {
                this.$message.success("Tool choice updated successfully");
                sendSocketMessage("chatbot/v2 tool-choice-changed", {
                    siteId: this.site._id,
                    storyId: this.story._id,
                    tool_choice: toolChoice,
                });
            });
        },
    },
    watch: {
        temperature: {
            handler(newVal, oldVal) {
                if (!this.initialized) return;
                log("temperature changed", newVal);
                window.logs.push({ log: "temperature changed", params: { newVal, oldVal } });
                if (this.story.ai?.temperature !== newVal) this.changeTemperature(newVal);
                this.key = this.getKey();
            },
            deep: true,
        },
        topP: {
            handler(newVal, oldVal) {
                if (!this.initialized) return;
                log("topP changed", newVal);
                window.logs.push({ log: "topP changed", params: { newVal, oldVal } });
                if (this.story.ai?.top_p !== newVal) this.changeTopP(newVal);
                this.key = this.getKey();
            },
            deep: true,
        },
        toolChoiceNone: {
            handler(newVal, oldVal) {
                if (!this.initialized) return;
                log("toolChoiceNone changed", newVal);
                window.logs.push({ log: "toolChoiceNone changed", params: { newVal, oldVal } });
                if (newVal && !oldVal) {
                    this.switchToolChoice("none");
                    this.updateStoryToolChoice();
                }
                this.key = this.getKey();
            },
            deep: true,
        },
        toolChoiceAuto: {
            handler(newVal, oldVal) {
                if (!this.initialized) return;
                log("toolChoiceAuto changed", newVal);
                window.logs.push({ log: "toolChoiceAuto changed", params: { newVal, oldVal } });

                if (newVal === true && oldVal === false) {
                    this.switchToolChoice("auto");
                    this.updateStoryToolChoice();
                }
                this.key = this.getKey();
            },
            deep: true,
        },
        toolChoiceRequired: {
            handler(newVal, oldVal) {
                if (!this.initialized) return;
                log("toolChoiceRequired changed", newVal);
                window.logs.push({ log: "toolChoiceRequired changed", params: { newVal, oldVal } });
                if (newVal && !oldVal) {
                    this.switchToolChoice("required");
                    this.updateStoryToolChoice();
                }
                this.key = this.getKey();
            },
            deep: true,
        },
    },
};
</script>
<style lang="scss">
#ChatbotAiPrompt {
    margin: 30px;

    .settings-btn {
        display: flex;
        gap: 20px;
        float: right;
        margin: 30px;
    }

    .parameter-tuning {
        display: flex;
        flex-direction: column;
        gap: 10px;

        input {
            width: 80px;
        }

        .modes {
            display: flex;
            flex-direction: column;
            gap: 5px;

            .mode-items {
                display: flex;
                gap: 10px;
            }
        }
    }
}
</style>
